import ActiveDealIndicator from './ActiveDealIndicator';
export default ActiveDealIndicator;